<template>
  <div id="app">
    <spinner></spinner>
    <alert></alert>
    <b-container fluid>
      <b-navbar id="nav-bar" :type="isOnHomeOrTrialPage ? 'light' : 'dark'" :variant="isOnHomeOrTrialPage ? 'white' : 'info'">
<!--        <b-navbar-brand :to="{path: '/'}" class="font-weight-bold" v-if="!isOnHomePage && isAuthenticated">CRT Hub</b-navbar-brand>
-->        <b-navbar-brand :to="{path: '/'}" class="font-weight-bold"><img src="logo32.jpg"></b-navbar-brand>
        <span class="navbar-text font-weight-bold text-white" v-if="envDescription">{{ envDescription }}</span>
        <b-collapse is-nav id="nav_collapse">
          <b-navbar-nav class="ml-auto">
            <b-nav-item exact exact-active-class="active font-weight-bold" :class="{'link-style': !isAuthenticated}" :to="{path: '/'}">Home</b-nav-item>
            <b-nav-item v-if="isOnHomePage" active-class="active font-weight-bold" :class="{'link-style': !isAuthenticated}" :to="{path: '/about_crt_hub'}">
              {{ !isAuthenticated ? 'About CRT hub' : 'About' }}
            </b-nav-item>
            <b-nav-item v-if="isOnHomePage" active-class="active font-weight-bold" :class="{'link-style': !isAuthenticated}" :to="{path: '/more_information'}">
              More Information
            </b-nav-item>
          </b-navbar-nav>
          <b-navbar-nav v-if="isAuthenticated && !isOnHomePage">
            <b-nav-item active-class="active font-weight-bold" :to="{path: '/deal_catalog'}">Deal Catalog</b-nav-item>
            <b-nav-item active-class="active font-weight-bold" :to="{path:'/deal_analysis', query: {dealName :  bondDeal}}">Deal Analysis</b-nav-item>
            <b-nav-item active-class="active font-weight-bold" :to="{path:'/bond_analysis', query: {dealName :  bondDeal}}">Bond Analysis</b-nav-item>
            <b-nav-item active-class="active font-weight-bold" :to="{path:'/acis_analysis', query: {dealName :  acisDeal}}">ACIS</b-nav-item>
            <b-nav-item active-class="active font-weight-bold" :to="{path:'/cirt_analysis', query: {dealName :  cirtDeal}}">CIRT</b-nav-item>
            <b-nav-item active-class="active font-weight-bold" :to="{path:'/loans'}">Loans</b-nav-item>
<!--
            <b-nav-item-dropdown id="create" right text="Create">
              <b-dropdown-item active-class="active font-weight-bold" :to="{path:'/deal_create', query: {dealType: 'CIRT'}}">CIRT</b-dropdown-item>
              <b-dropdown-item active-class="active font-weight-bold" :to="{path:'/deal_create/acis'}">ACIS</b-dropdown-item>
              <b-dropdown-item active-class="active font-weight-bold" :to="{path:'/deal_create/stacr'}">STACR</b-dropdown-item>
              <b-dropdown-item active-class="active font-weight-bold" :to="{path:'/deal_create/Bond'}">Bond</b-dropdown-item>
              <b-dropdown-item active-class="active font-weight-bold" :to="{path:'/deal_create/Deal'}">Deal</b-dropdown-item>
            </b-nav-item-dropdown>
-->
            <b-nav-item-dropdown id="portfolio_ddown" right text="Portfolio">
              <b-dropdown-item active-class="active font-weight-bold" :to="{path:'/portfolio'}">Portfolio Setup</b-dropdown-item>
              <b-dropdown-item active-class="active font-weight-bold" :to="{path:'/vendor_grid'}">Multi-Scenario</b-dropdown-item>
            </b-nav-item-dropdown>
            <b-nav-item-dropdown id="vectors_ddown" right text="Vectors">
              <b-dropdown-item active-class="active font-weight-bold" :to="{path:'/vector_list'}">Vectors</b-dropdown-item>
              <b-dropdown-item active-class="active font-weight-bold" :to="{path:'/scenario_list'}">Scenarios</b-dropdown-item>
              <b-dropdown-item active-class="active font-weight-bold" :to="{path:'/cashflows'}">Cashflows</b-dropdown-item>
            </b-nav-item-dropdown>
            <b-nav-item active-class="active font-weight-bold" :to="{path:'/reports'}">Reports</b-nav-item>
            <b-nav-item active-class="active font-weight-bold" :to="{path:'/docs'}" v-if="this.$store.getters.isDocReader">Documentation</b-nav-item>
            <b-nav-item-dropdown id="admin_ddown" right text="Admin" v-if="this.$store.getters.isAdmin">
              <b-dropdown-item active-class="active font-weight-bold" :to="{path:'/admin'}">User Management</b-dropdown-item>
              <b-dropdown-item active-class="active font-weight-bold" :to="{path:'/admin_reports'}">Report Management</b-dropdown-item>
              <b-dropdown-item active-class="active font-weight-bold" :to="{path:'/admin_adco'}">Model Management</b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>
          <b-navbar-nav v-else-if="isOnHomePage && !isAuthenticated">
            <login/>
          </b-navbar-nav>
          <b-navbar-nav v-if="isAuthenticated">
            <b-nav-item-dropdown id="username_ddown" right :text="username">
              <b-dropdown-item active-class="active font-weight-bold" :to="{path:'/settings'}">Settings</b-dropdown-item>
              <b-dropdown-item active-class="active font-weight-bold" @click="logout()">Log Out</b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>
          <b-navbar-nav v-if="isOnHomePage && isAuthenticated">
            <b-nav-item active-class="active font-weight-bold" :to="{path: '/deal_catalog'}">Enter CRT Hub</b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
      <div class="content-wrapper">
        <router-view></router-view>
      </div>
    </b-container>
  </div>
</template>

<script>
import Landing         from "./components/Landing";
import LandingRegister from "./components/LandingRegister";
import moment          from "moment";
import Login           from './components/Login';
import spinner         from '@/components/common/spinner';
import alert           from '@/components/common/alert';

export default {
  mounted:       function () {
    this.$el.addEventListener('click', this.logoutIfNeeded);
    return null;
  },
  beforeDestroy: function () {
    this.$el.removeEventListener('click', this.logoutIfNeeded);
  },
  computed:      {
    isOnHomeOrTrialPage() {
      return this.isOnHomePage || this.$route.path == '/trial';
    },
    isOnHomePage() {
      return ['/', '/about_crt_hub', '/more_information'].includes(this.$route.path);
    },
    mainPageLink() {
      let result = '/deal_catalog';
      if (this.$route.query.utm_term) {
        return result + '/?utm_term=' + this.$route.query.utm_term;
      }
      return result;
    },
    isAuthenticated() {
      return this.$store.getters.authenticated;
    },
    username() {
      return this.$store.getters.username;
    },
    envDescription() {
      return window.ENVIRONMENT_DESCRIPTION;
    },
    bondDeal() {
      this.$store.getters.lastBondDeal
      if (this.$cookies.isKey("lastBondDeal")) {
        return this.$cookies.get("lastBondDeal")
      }
      return this.$store.getters.dealName;
    },
    acisDeal() {
      this.$store.getters.lastAcisDeal
      if (this.$cookies.isKey("lastAcisDeal")) {
        return this.$cookies.get("lastAcisDeal")
      }
      return this.$store.getters.dealName;
    },
    cirtDeal() {
      this.$store.getters.lastCirtDeal
      if (this.$cookies.isKey("lastCirtDeal")) {
        return this.$cookies.get("lastCirtDeal")
      }
      return this.$store.getters.dealName;
    }
  },
  methods:       {
    logoutIfNeeded() {
      if (moment(this.$store.getters.expires, "YYYY-MM-DD HH:mm::ss Z") < moment()) {
        this.logout();
      }
    },
    logout() {
      this.$store.commit("logout");
      this.$root.$router.push({path: "/"});
    }
  },
  components:    {
    spinner,
    alert,
    Landing,
    LandingRegister,
    Login
  },
  name:          "app"
};
</script>

<style lang="scss">
@import "../node_modules/bootstrap/scss/_functions.scss";
@import "../node_modules/bootstrap/scss/_variables.scss";

$grid-breakpoints: (
    xs: 0,
    sm: 600px,
    md: 800px,
    lg: 1000px,
    xl: 1315px
);

@import "../node_modules/bootstrap/scss/bootstrap.scss";
html {
  scroll-behavior: smooth !important;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  font-size: 0.9rem !important;
  color: #2c3e50;
  padding-top: 56px;
}

#nav_collapse {
  min-width: 800px;
}

.logo {
  padding-right: 32px;
}

.loader-wrapper {
  position: fixed;
  z-index: 2080;
  top: 55px;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.8);

  .loader {
    position: absolute;
    top: calc(35% - 50px);
    left: calc(50% - 50px);
    border: 10px solid #d3c9c9;
    border-top: 10px solid #17a2b8;
    border-radius: 50%;
    width: 100px;
    height: 100px;
    animation: spin 1s linear infinite;
    margin: 50px auto;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.btn {
  border-radius: 0 !important;
  font-size: 0.8rem !important;
}

.dropdown-menu {
  font-size: 0.8rem !important;
}

.table td {
  vertical-align: middle !important;
}

.mw-1160 {
  min-width: 1160px;
}

.table-caption {
  caption-side: top;
  text-align: center;
  padding: 0 0;
  color: #fff;
  background-color: #17a2b8;
}

#nav-bar {
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 2;
}

.content-wrapper {
  z-index: 1;
  display: inline-block;
  width: 100%;
}

.form-control {
  font-size: 0.8rem !important;
  //padding: 0.275rem 2rem 0.275rem 0.25rem !important;
}

.mx-datepicker {
  position: relative;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  width: 1%;
  margin-bottom: 0;

  .mx-input-wrapper {
    .mx-input-append {
      display: none;
    }
  }

  .mx-input-wrapper input {
    min-width: 13ch;
    padding-right: 30px;
  }

  .mx-datepicker-popup {
    white-space:nowrap;
    right: 0;
    top: 3em !important;
    left: auto !important;

    tr, td {
      border: none;
    }

    .mx-calendar {
      background-color: #fff !important;
      &-content {
        width: auto;

        .cell {
          &.actived {
            background-color: #17a2b8;
          }
        }
      }
    }
  }
}

table .sticky {
  position: -webkit-sticky;
  position: sticky;
  top: 55px;
  background-color: white;

  &-header {
    top: 83px;
  }
}

.md-button {
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2),
  0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  width: 56px;
  height: 56px;
  border-radius: 50%;
  outline: none;
  border: 0;
  font-size: 250%;
  background-color: #17a2b8 !important;
  color: white;
  display: block;
  margin: 0 auto;

  &.remove {
    background-color: #908b8b !important;
    width: 20px;
    height: 20px;
    font-size: 85%;

    &:hover {
      background-color: #dc3545 !important;
      cursor: pointer;
    }
  }

  &.edit {
    background-color: #908b8b !important;
    width: 20px;
    height: 20px;
    font-size: 85%;

    &:hover {
      color: black !important;
      background-color: #e8e843 !important;
      cursor: pointer;
    }
  }
}

#username_ddown {
  & > div {
    min-width: 5rem !important;
  }
}

.dropdown-item {
  &.active, &:active {
    color: #fff;
    text-decoration: none;
    background-color: #17a2b8 !important;
  }
}

.calculation-settings-input {
  text-align: right;
  font-size: 0.8rem;
  padding: 0 10px;

  &:focus {
    border-color: #17a2b8;
    box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.25);
  }
}

.custom-select {
  height: 1.85rem !important;
  font-size: 0.8rem !important;
  border-radius: 0.25rem;
}

.blue {
  color: blue;
}

.link-style a {
  color: #007bff !important;
}

.transparent {
  color: rgba(0, 0, 0, 0);
}
</style>
